<span class="product-type-label">{{text | translate}}</span>